// extracted by mini-css-extract-plugin
export var chevron = "_21-d";
export var disabled = "_21-b";
export var error = "_21-c";
export var hideBorder = "_21-1";
export var icon = "_21-e";
export var input = "_21-0";
export var large = "_21-f";
export var open = "_21-9";
export var placeholder = "_21-a";
export var regular = "_21-5";
export var singleRowInput = "_21-2";
export var singleSelectInput = "_21-3 _21-0";
export var small = "_21-4";
export var spinnerContainer = "_21-i";
export var tag = "_21-7";
export var tagsContainer = "_21-8";
export var tagsInput = "_21-6 _21-0";
export var xSmall = "_21-g";
export var xxSmall = "_21-h";